const initCursor = () => {
    const cursor = document.querySelector('#cursor');

    if (cursor) {
        const cursorCircle = cursor.querySelector('.circle');

        if (cursorCircle) {

            // Hide the default cursor
            document.body.style.cursor = 'none';

            // Cache DOM elements and initial state
            const mouse = {x: -100, y: -100};
            const pos = {x: 0, y: 0};
            const speed = 0.5;

            // Event listeners
            window.addEventListener('mousemove', updateCoordinates);

            // Update mouse coordinates on mouse move
            function updateCoordinates(e) {
                mouse.x = e.clientX;
                mouse.y = e.clientY;
            }

            // Calculate angle between cursor and mouse pointer
            function getAngle(diffX, diffY) {
                return Math.atan2(diffY, diffX) * 180 / Math.PI;
            }

            // Calculate squeeze effect based on cursor and mouse pointer distance
            function getSqueeze(diffX, diffY) {
                const distance = Math.sqrt(Math.pow(diffX, 2) + Math.pow(diffY, 2));
                const maxSqueeze = 0.15;
                const accelerator = 1500;
                return Math.min(distance / accelerator, maxSqueeze);
            }

            // Update custom cursor position and appearance
            function updateCursor() {
                const diffX = Math.round(mouse.x - pos.x);
                const diffY = Math.round(mouse.y - pos.y);

                pos.x += diffX * speed;
                pos.y += diffY * speed;

                const angle = getAngle(diffX, diffY);
                const squeeze = getSqueeze(diffX, diffY);
                const scale = `scale(${1 + squeeze}, ${1 - squeeze})`;
                const rotate = `rotate(${angle}deg)`;

                cursor.style.transform = `translate3d(${pos.x}px, ${pos.y}px, 0)`;
                cursorCircle.style.transform = rotate + scale;
            }

            // Animation loop
            function loop() {
                updateCursor();
                requestAnimationFrame(loop);
            }

            // Initialize animation loop
            requestAnimationFrame(loop);

            // Apply cursor modifiers
            const cursorModifiers = document.querySelectorAll('[data-cursor-class]');

            cursorModifiers.forEach(cursorModifier => {
                cursorModifier.addEventListener('mouseenter', function () {
                    const className = this.getAttribute('data-cursor-class');
                    cursor.classList.add(className);
                });

                cursorModifier.addEventListener('mouseleave', function () {
                    const className = this.getAttribute('data-cursor-class');
                    cursor.classList.remove(className);
                });
            });
        }
    }
}

export default initCursor;